import { render, staticRenderFns } from "./ResumeMyCollection.vue?vue&type=template&id=13265617&scoped=true&"
import script from "./ResumeMyCollection.vue?vue&type=script&lang=js&"
export * from "./ResumeMyCollection.vue?vue&type=script&lang=js&"
import style0 from "./ResumeMyCollection.vue?vue&type=style&index=0&id=13265617&lang=less&scoped=true&"
import style1 from "./ResumeMyCollection.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13265617",
  null
  
)

export default component.exports